import { lazy } from 'react';

const list = lazy(() => import('pages/shipments/List'));
const show = lazy(() => import('pages/shipments/Show'));

export { list, show };
